export default {
  chatEndedLabel: 'Chat has ended',
  chatConversationHasMoved: 'Conversation has moved',
};
